import React from 'react';
import AdminManageSettingsDataUpload from './admin-manage-settings-data-upload';
import AdminManageSettingsComparisonTable from './admin-manage-settings-comparison-table';
import * as adminService from '../../services/admin-service';

const poolAccountsConfig = {
  title: 'Manage Pool Accounts',
  description: 'Upload an Excel file containing pool account data to compare with existing records and update as needed.',
  uploadTitle: 'Upload Pool Accounts File',
  entityName: 'pool accounts',
  fileInputId: 'pool-accounts',
  uploadService: adminService.uploadPoolAccountsFile,
  bulkUpdateService: adminService.bulkUpdatePoolAccounts,
  downloadFileService: adminService.downloadPoolAccountsFile,
  getFileInfoService: adminService.getPoolAccountsFileInfo,
  idField: 'producer_code',
  columns: [
    { field: 'producer_code', label: 'Producer Code', className: 'admin-pool-comparison-col-code' },
    { field: 'name', label: 'Name', className: 'admin-pool-comparison-col-name' },
    { field: 'functional_unit_code', label: 'Functional Unit', className: 'admin-pool-comparison-col-fu' },
    { field: 'office', label: 'Office', className: 'admin-pool-comparison-col-office' },
    { field: 'description', label: 'Description', className: 'admin-pool-comparison-col-description' },
  ],
  
  viewAllConfig: {
    entityName: 'Pool Accounts',
    fetchAllService: adminService.fetchPoolAccounts,
    idField: 'producer_code',
    searchFields: ['producer_code', 'name', 'description', 'office'],
    columns: [
      { key: 'producer_code', label: 'PRODUCER CODE', width: '160px' },
      { key: 'name', label: 'NAME', width: '200px' },
      { key: 'functional_unit_code', label: 'FUNCTIONAL UNIT', width: '180px' },
      { key: 'managing_office_code', label: 'MANAGING OFFICE CODE', width: '200px' },
      { key: 'office', label: 'OFFICE', width: '200px' },
      { key: 'description', label: 'DESCRIPTION', width: '250px' },
      { key: 'pool_account_name', label: 'POOL ACCOUNT NAME', width: '220px' },
    ],
  },
};

const AdminManagePoolAccounts = () => {
  return (
    <AdminManageSettingsDataUpload
      config={poolAccountsConfig}
      ComparisonTableComponent={AdminManageSettingsComparisonTable}
    />
  );
};

export default AdminManagePoolAccounts;

